module.exports = __webpack_public_path__ + "img/b1.43c08440.png";